export class ComGoalEmployeeJobModel {
    public commission?:number;
    public coordinatorManage?:boolean;

    public employeeJobId?:number;
    public feeEmployeeJobId?:number;
    public goalEmployeeJobId?:number;
    public maxGoal?:number;
    public minGoal?:number;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}
